const OPIATE_FAMILY_ATC_PREFIXES = ['N07BC', 'N02A'] as const

function normalizeAtcCode(code: string): string {
  return code.trim().toUpperCase()
}

export function isOpiateFamilyAtcCode(atcCode?: string | null): boolean {
  if (!atcCode) return false
  const normalizedCode = normalizeAtcCode(atcCode)
  return OPIATE_FAMILY_ATC_PREFIXES.some((prefix) => normalizedCode.startsWith(prefix))
}

export function hasOpiateFamilyAtcCode(atcCodes?: Array<string | null | undefined>): boolean {
  if (!atcCodes || atcCodes.length === 0) return false
  return atcCodes.some((atcCode) => isOpiateFamilyAtcCode(atcCode))
}

export { OPIATE_FAMILY_ATC_PREFIXES }
